@use "~theme/typography";
@use "~theme/breakpoints";

.content {
  padding: 24px 24px 0;

  @include breakpoints.desktop {
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
  }
}

.addressFieldGroup {
  @include breakpoints.mobile-large {
    display: grid;
    grid-gap: 0 16px;
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
}

.alwaysVisible {
  display: inherit;
}

.inlineLegend {
  @include breakpoints.desktop {
    top: 0;
  }
}

.apt {
  margin: 3px 0 16px;
}

.field {
  margin: 0 0 16px;
}

.fieldSpan {
  grid-column: 1 / span 2;
}

.buttonGroup {
  margin: 12px 0 16px;
}

.birthSexFieldGroup {
  @include breakpoints.desktop {
    min-height: 20px;
  }
}

.birthSexButtonGroup {
  @include breakpoints.desktop {
    margin-top: 0;
  }
}

.radioButton {
  margin-bottom: 16px;
}

.emptyError {
  display: none;
}

.toggle {
  margin-bottom: 16px;

  @include breakpoints.desktop {
    margin-top: 28px;
  }
}

.separator {
  border: 0;
  border-bottom: 1px solid var(--blue-01-at-30);
  margin-bottom: 24px;

  @include breakpoints.desktop {
    margin: {
      top: 0;
      bottom: 24px;
    }
  }
}

.bodyLarge {
  @include typography.body-large;
}
